import fetch from "@/common/js/http";

const project = {
  namespaced: true,
  mutations: {},
  actions: {
    // 项目列表
    getProjectList({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "pct/project/list",
          method: "get",
          params: params
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    // 项目预算 及 项目绩效
    getProjectBudget({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "pct/project/budget",
          method: "get",
          params: params
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    // 报销控制
    reimbursementControl({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "pct/reimbursement/control",
          method: "get",
          params: params
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
  },
};

export default project;



// WEBPACK FOOTER //
// ./src/vuex/modules/projectPerformance.js